import React from 'react';
import classNames from 'classnames';
import { withNativeProps } from '../../utils/native-props';
import { EmptyIcon } from './empty-icon';
var classPrefix = "adm-empty";
export var Empty = function Empty(props) {
  function renderImageNode() {
    var image = props.image;

    if (image === undefined) {
      return React.createElement(EmptyIcon, {
        className: "".concat(classPrefix, "-image"),
        style: props.imageStyle
      });
    }

    if (typeof image === 'string') {
      return React.createElement("img", {
        className: "".concat(classPrefix, "-image"),
        style: props.imageStyle,
        src: image,
        alt: 'empty'
      });
    }

    return image;
  }

  return withNativeProps(props, React.createElement("div", {
    className: classPrefix
  }, React.createElement("div", {
    className: "".concat(classPrefix, "-image-container")
  }, renderImageNode()), props.description && React.createElement("div", {
    className: classNames("".concat(classPrefix, "-description"))
  }, props.description)));
};